export default __webpack_public_path__ + "static/media/pic10.47a0ee6e.jpg";